/**
 * PolicyManagementPage - Policy management
 *
 * Surfaces the PolicyManager from @ferp/workflow-forms for admin/architect users.
 * Provides full CRUD management of business rules and compliance policies.
 *
 * Route: /admin/policy-management
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconShield } from '@tabler/icons-react';

import { PolicyManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function PolicyManagementPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="grape">
            <IconShield size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Policy Management</Title>
            <Text size="sm" c="dimmed">
              Manage business rules, compliance policies, and enforcement
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <PolicyManager tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default PolicyManagementPage;
